function CustomTextarea({ props }) {
  return (
    <div className="w-full">
      <textarea
        disabled={props.disabled}
        placeholder={props.placeholder || "Nhập " + props.label}
        defaultValue={props.defaultValue || ""}
        rows={props.rows || 4}
        {...props.register(props.name, {
          required: props.isRequired && `${props.label} là bắt buộc !`,
          ...(props.validate ? { validate: props.validate } : {}),
          ...(props.pattern ? { pattern: props.pattern } : {}),
        })}
        className="w-full p-2 border border-gray-300 rounded-lg
                   focus:outline-none focus:ring-2 focus:ring-blue-500
                   "
        {...props}
      />

      <p className="text-sm mt-1 min-h-[20px] text-red-500">
        {props.errors?.[props.name]?.message || "\u00A0"}
      </p>
    </div>
  );
}

export default CustomTextarea;
